import type { CountryConfig } from './typing';

export const statements: CountryConfig = {
    enabled: true,
    deliveryDefinitions: {
        distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
        format: ['PDF_A4', 'XML_SEPA', 'TXT_MT940'],
        periodicity: [
            'DAILY',
            'WEEKLY',
            'MONTHLY',
            'QUARTERLY',
            'HALFYEARLY',
            'YEARLY',
            '10_YEARLY',
        ],
        channelEditable: true,
        statementNumberEditable: true,
    },
    tableColumns: [
        { id: 'name', label: 'main.settings.name', width: '25%' },
        { id: 'date', label: 'account.statements.statementDate', width: '25%' },
        {
            id: 'periodicity',
            label: 'account.statements.deliveryDefinitions.periodicity',
            width: '15%',
        },
        { id: 'language', label: 'account.statements.language', width: '15%' },
        { id: 'download', label: 'app.download', width: '20%' },
    ],
};
